var map = {
	"./01_get_common_symbols.json": "o8W7",
	"./02_get_ market_traders.json": "SDL0",
	"./03_get_market_depth.json": "2qJV",
	"./04_get_market_klines.json": "/lsz",
	"./05_get_quote_ticker.json": "wj44",
	"./06_get_market_agg_depth.json": "cYhj",
	"./07_get_market_price.json": "ymfm",
	"./08_get_market_book_ticker.json": "Tbeq",
	"./09_get_market_history_klines.json": "7UNC",
	"./10_get_ market_histroy_traders.json": "cRRp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kxYJ";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/api/market \.json$
// module id = kxYJ
// module chunks = 3